  <p>
    <span data-dismiss="modal" aria-label="Close"  class="cursor-pointer mr-2">
    <span aria-hidden="true">
      <img class="float-right" (click)="fcs.closeWebModal()" src="assets/themes/icons/cancel.svg" alt="cross"/>
    </span>
    </span>
  </p>
  <div class="clearfix text-center mt-2 mb-2">
  <img class="mb-3" width="155px" src="assets/themes/images/verification-pending.svg" />
  
  <h5 class="mb-3 heading-4"><span class="color-grey-700">{{data?.pre_document_card?.heading_text}}</span></h5>
  
  <p class="paragraph mb-4">{{data?.pre_document_card?.description_text}}</p>
  
  <button (click)="verifiNow()"  class="btn-design medium filled">{{data?.pre_document_card?.button?.text}}</button>
  </div>